/*@ngInject*/
const TextInputFilterController = function ($scope, advancedFilterModel, coreConstant,
                                            submissionConstant, localization) {



    this.$onInit = function () {

        this.searchDelayInMilliSeconds = submissionConstant.searchDelay;

        this.tooltip = {
            delay: 750
        };

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.placeholder = _.get(translations.textInputFilter, this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
            this.tooltip.message = translations.removeButtonTooltip;
        });

        if (_.includes(_.toLower(this.criterionTemplate.name), 'premium')) {
            this.isCurrency = true;
        }
        if (_.includes(_.toLower(this.criterionTemplate.name), 'insured')) {
            this.isInsured = true;
        }
        this.isOpen = true;
    };

    this.handleChange = function () {
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.getComponentId = function (filterCriterionTemplate) {
        return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = '';
        }
    }.bind(this));
};

angular.module('umCore')
    .controller('textInputFilterController', TextInputFilterController);
